// extracted by mini-css-extract-plugin
module.exports = {"w134myb3":"w134myb3"};